module.exports = __webpack_public_path__ + "static/media/shovel.0b240d78.svg";